import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { keys } from 'lodash'
import { toast } from 'react-toastify'
import callable from '../utils/callable'
import { getManagerApprovalCodes } from '../selectors/employeeRole'

import { setManagerId } from '../actions/attendant'
import { getCurrentMenu } from '../selectors/menus'
import UserLoginComponent from '../components/userLogin/Component'

/**
 * TODO: It is unconvential to return React components in a hook.
 * This should be replace with a more convential and flexible system
 * When time permits.
 *
 * TODO: T32803 deprecate the usage of this hook in favor of the new manager approval component
 *
 */
const useManagerApproval = () => {
  const approvalCodeToManagerMap = useSelector(getManagerApprovalCodes)
  const dispatch = useDispatch()
  const [modalElement, setModalElement] = useState(null)

  const menu = useSelector(getCurrentMenu)

  const handleSubmit = (pin, success, failure) => {
    if (!!approvalCodeToManagerMap[pin]) {
      dispatch(setManagerId(approvalCodeToManagerMap[pin]))
      callable(success)
      setModalElement(null)
    } else {
      callable(failure)
      toast.error("Invalid Approval Code, Please Try Again", { autoClose: 2500, })
    }
  }

  const requestApproval = (onSuccess, onFailure, buttonText) => {
    setModalElement(
      <UserLoginComponent
        standName={menu?.standName}
        handleSubmit={(pin) => handleSubmit(pin, onSuccess, onFailure)}
        hamburgerUnlocked={true}
        header={"Input Manager Pin"}
        forManagerApproval={true}
        approvalCodes={keys(approvalCodeToManagerMap)}
        buttonText={buttonText}
      />
    )
  }

  return [modalElement, requestApproval]
}

export default useManagerApproval